import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

/**
 * Pusty stan (poza tabelą) — wolnostojący wariant do sekcji, list, kalendarzy.
 * Sklonowany ze wzorca ITE Workflow365.
 *
 *   <EmptyState icon={CalendarOff} title="Brak wniosków"
 *     description="Nie złożono jeszcze żadnego wniosku." action={<Button>Złóż wniosek</Button>} />
 */
interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: ReactNode;
  size?: 'sm' | 'md';
  className?: string;
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  size = 'md',
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center',
        size === 'sm' ? 'py-8' : 'py-14',
        className,
      )}
    >
      {Icon && (
        <div
          className={cn(
            'mb-4 flex items-center justify-center rounded-2xl bg-gray-100 dark:bg-gray-800',
            size === 'sm' ? 'h-12 w-12' : 'h-16 w-16',
          )}
        >
          <Icon
            className={cn(
              'text-gray-400 dark:text-gray-500',
              size === 'sm' ? 'h-6 w-6' : 'h-8 w-8',
            )}
          />
        </div>
      )}
      <h3
        className={cn(
          'font-semibold text-gray-900 dark:text-gray-100',
          size === 'sm' ? 'text-sm' : 'text-base',
        )}
      >
        {title}
      </h3>
      {description && (
        <p className="mt-1 max-w-sm text-sm text-gray-500 dark:text-gray-400">{description}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export default EmptyState;
